/*
  Fabrix Home: <fx-card> (snippets/fabrix-card.liquid). Onaylı prototipteki card() davranışı:
  - Genel renk değişince ('fabrix:renk') kart o renkteki varyanta geçer, yoksa "<Renk> rengi yok" etiketi görünür.
  - Kartın kendi renk noktaları yalnız o kartı değiştirir; seçili renk ilk sırada, en çok 5 nokta + "+N".
  - Üzerine gelince ikinci görsel (sahne > ikinci stüdyo > sonraki varyant).
  - Hızlı ekle: FabrixCart.addLines.
*/
class FxCard extends HTMLElement {
  connectedCallback() {
    this.data = window.FabrixRenk.data(this.querySelector('[data-fx-json]'));
    if (!this.data) return;
    const initial = window.FabrixRenk.match(this.data.variants, this.dataset.renk);
    this.cur = initial || this.data.variants[0];
    this.matched = !!initial;
    this.render(false);
    this.addEventListener('click', (e) => this.onClick(e));
    // Seccade kartları (tall) genel rengi izlemez: desenler ürüne özgü, sofrada seçilen renk seccadede başka ürün açtırıyordu.
    // Renk filtresi olmayan sayfada (data-renksiz) da izlemez.
    if (this.classList.contains('fx-card--tall') || this.hasAttribute('data-tek') || this.hasAttribute('data-renksiz')) return;
    this.onRenk = (e) => this.follow(e.detail.slug);
    document.addEventListener('fabrix:renk', this.onRenk);
    if (window.FabrixRenk.current && window.FabrixRenk.current !== this.dataset.renk) this.follow(window.FabrixRenk.current);
  }
  disconnectedCallback() { if (this.onRenk) document.removeEventListener('fabrix:renk', this.onRenk); }

  follow(slug) {
    const v = window.FabrixRenk.match(this.data.variants, slug);
    this.matched = !!v;
    if (v) this.cur = v;
    this.render(true);
  }

  render(swapImage) {
    const { data, cur } = this;
    const tek = data.variants.length < 2 || this.classList.contains('fx-card--tall');
    const badge = this.querySelector('[data-badge]');
    if (badge) badge.hidden = this.matched || tek || this.hasAttribute('data-renksiz');
    const main = this.querySelector('[data-main]');
    if (swapImage && main && cur.img) { main.removeAttribute('srcset'); main.src = cur.img; main.alt = `${data.title}, ${cur.renk}`; }
    const alt = this.querySelector('[data-alt]');
    const next = data.variants[data.variants.indexOf(cur) + 1] || data.variants[0];
    // Tek renk kartında üzerine gelince başka rengin görseli gösterilmez
    const altSrc = cur.sahne || cur.img2 || (next !== cur && !this.hasAttribute('data-tek') ? next.img : null);
    if (alt) { if (altSrc) { alt.src = altSrc.replace('width=1800', 'width=900'); alt.hidden = false; } else alt.hidden = true; }
    const url = `${data.url}?variant=${cur.id}`;
    this.querySelectorAll('[data-link]').forEach((a) => (a.href = url));
    const add = this.querySelector('[data-add]');
    if (add) add.hidden = !cur.price || !cur.available;
    const price = this.querySelector('[data-price]');
    if (price) price.textContent = cur.price ? window.FabrixRenk.money(cur.price) : 'Yakında';
    const picker = this.querySelector('[data-card-picker]');
    if (picker) {
      // Fotoğrafı olmayan ve tükenen renk gösterilmez (açılınca başka rengin fotoğrafı görünüyordu)
      const vis = data.variants.filter((x) => x === cur || x.own !== false || x.available);
      const shown = [cur].concat(vis.filter((x) => x !== cur)).slice(0, 5);
      picker.innerHTML =
        shown.map((x) => `<button type="button" class="fx-sw fx-sw--sm" style="background:${x.sw}" aria-label="${x.renk}" title="${x.renk}" aria-pressed="${x === cur}" data-v="${x.id}"></button>`).join('') +
        (vis.length > 5 ? `<span class="fx-more">+${vis.length - 5}</span>` : '');
    }
  }

  async onClick(e) {
    const sw = e.target.closest('[data-v]');
    if (sw) {
      this.cur = this.data.variants.find((x) => String(x.id) === sw.dataset.v) || this.cur;
      this.matched = true;
      this.render(true);
      return;
    }
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      try { await window.FabrixCart.addLines([{ id: this.cur.id, quantity: 1 }], 'fabrix-card'); }
      catch (err) { console.error(err); }
      finally { add.removeAttribute('aria-busy'); }
    }
  }
}
if (!customElements.get('fx-card')) customElements.define('fx-card', FxCard);
